import { Icon_BackArrow, Icon_ExclamationFilled16, Sidebar } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import useNavigation from "../../../../hooks/navigation";
import useAccount from "../../../../hooks/useAccount";
import { useChinaUser } from "../../../../hooks/useChinaUser";
import { useTeam } from "../../../../hooks/useTeams";
import useTranslation from "../../../../hooks/useTranslation";
import { NavGroup } from "../NavGroup/NavGroup";
import { NavItem } from "../NavItem/NavItem";

import style from "./SettingsNavGroup.module.css";

export const SettingsNavGroup = () => {
  const { t, m } = useTranslation();
  const navigation = useNavigation();
  const { teamID } = useParams();

  const { teamData, isOwner, isSeatManager, isGuest } = useTeam(teamID);

  const { data: accountData } = useAccount();
  const { isChinaUser } = useChinaUser();

  const showBackToDashboard = !teamData?.addons?.syncForbidden;

  const canManageTeam = isOwner;
  const canManageSpaces = isSeatManager && teamData?.addons?.teamspaceManagement;
  const showAdminSection = Boolean(teamID && (!isGuest || canManageTeam || canManageSpaces));
  const showMembers =
    !isGuest && (isChinaUser === false || Boolean(accountData?.hasChargebeeSubscription));
  return (
    <NavGroup>
      <Sidebar.ScrollContainer>
        {teamID && (
          <>
            {showBackToDashboard && (
              <>
                <Sidebar.Item
                  onClick={() => {
                    navigation.goToSharedWithMe({ teamID });
                  }}
                >
                  <Icon_BackArrow /> {t(m.General.BackToDashboard)}
                </Sidebar.Item>
                <Sidebar.Divider />
              </>
            )}
            {showAdminSection && <Sidebar.Header>{t(m.General.Admin)}</Sidebar.Header>}
            {showMembers && <NavItem name="members">{t(m.General.Members)}</NavItem>}
            {canManageTeam && (
              <>
                <NavItem name="subscription">
                  <span>{isChinaUser ? t(m.General.License) : t(m.General.Subscription)}</span>
                  {accountData && accountData?.subscriptionInGracePeriod && (
                    <Icon_ExclamationFilled16 className={style.subscriptionWarningIcon} />
                  )}
                </NavItem>
                {/*
                           Currently this is a shorthand instead of requesting team/:teamID/subscriptions and checking if that contains
                           an individual chargebee sub, this works since you will see this menu only if you are an owner, and if you are the owner
                           the individual sub will be also in the account response
                      */}
                {accountData?.hasChargebeeSubscription && (
                  <NavItem name="billing">{t(m.General.Billing)}</NavItem>
                )}
              </>
            )}
            {(canManageSpaces || canManageTeam) && (
              <NavItem name="settings">{t(m.General.TeamSettings)}</NavItem>
            )}
          </>
        )}
      </Sidebar.ScrollContainer>
      <Sidebar.Space marginTop={"auto"} />
      <Sidebar.Divider />
      <Sidebar.Space marginBottom={-20} />
      <Sidebar.Header>{t(m.General.MyAccount)}</Sidebar.Header>
      <NavItem name="">{t(m.General.AccountSettings)}</NavItem>
    </NavGroup>
  );
};
